import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import withRouter from "components/Common/withRouter";
// ➡️ IMPORT TAMBAHAN: useLocation dari react-router-dom
import { useLocation } from "react-router-dom"; 
import {
  changeLayout,
  changeLayoutMode,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
  showRightSidebarAction
} from "../../store/actions";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import RightSidebar from "../CommonForBoth/RightSidebar";
import PanduanTour from "../PanduanTour";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';

const Layout = props => {
  const dispatch = useDispatch();
  // ➡️ KUNCI 1: Inisialisasi useLocation
  const location = useLocation(); 
  
  // ➡️ KUNCI 2: Tentukan apakah path adalah halaman POS (Penjualan Langsung)
  const isPosPage = location.pathname === "/penjualan/add";


  const selectLayoutProperties = createSelector(
    (state) => state.Layout,
    (layout) => ({
      isPreloader: layout.isPreloader,
      layoutModeType: layout.layoutModeType,
      leftSideBarThemeImage: layout.leftSideBarThemeImage,
      leftSideBarType: layout.leftSideBarType,
      layoutWidth: layout.layoutWidth,
      topbarTheme: layout.topbarTheme,
      showRightSidebar: layout.showRightSidebar,
      leftSideBarTheme: layout.leftSideBarTheme,
    }));

  const {
    isPreloader,
    leftSideBarThemeImage,
    layoutWidth,
    leftSideBarType,
    topbarTheme,
    showRightSidebar,
    leftSideBarTheme,
    layoutModeType
  } = useSelector(selectLayoutProperties);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);


  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile));
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile));
    }
  };

  // Nilai showRightSidebar terbaru untuk listener body (listener dipasang
  // sekali; closure lama tidak ikut berubah).
  const rightSidebarTerbukaRef = useRef(showRightSidebar);
  useEffect(() => {
    rightSidebarTerbukaRef.current = showRightSidebar;
  }, [showRightSidebar]);

  //hides right sidebar on body click
  const hideRightbar = (event) => {
    // Sidebar kanan sudah tertutup -> tidak perlu dispatch. Dulu aksi ini
    // dikirim pada SETIAP klik; re-render layout yang ditimbulkannya
    // membuat checkbox yang sedang diklik kembali ke nilai lama sebelum
    // React sempat memproses onChange (checkbox tampak tidak bisa dicentang).
    if (!rightSidebarTerbukaRef.current) return;

    var rightbar = document.getElementById("right-bar");
    //if clicked in inside right bar, then do nothing
    if (rightbar && rightbar.contains(event.target)) {
      return;
    } else {
      //if clicked in outside of rightbar then fire action for hide rightbar
      dispatch(showRightSidebarAction(false));
    }
  };

  /*
  layout  settings
  */

  useEffect(() => {
    // init body click event fot toggle rightbar
    document.body.addEventListener("click", hideRightbar, true);
    
    // ➡️ KUNCI 3: PENGATURAN CLASS BODY BERDASARKAN isPosPage
    if (isPosPage) {
        document.body.classList.add("pos-full-width-mode");
        // Hapus class yang mengaktifkan sidebar, ini penting!
        document.body.classList.remove("sidebar-enable"); 
        document.body.classList.remove("vertical-collpsed"); // Jika mode condensed
    } else {
        document.body.classList.remove("pos-full-width-mode");
        // Kembalikan class default jika Anda mengandalkan class ini untuk tampilan
        // document.body.classList.add("sidebar-enable"); 
    }

    return () => {
        document.body.removeEventListener("click", hideRightbar, true);
        // Pastikan class full-width dihapus saat navigasi
        document.body.classList.remove("pos-full-width-mode"); 
    };
  }, [isPosPage]); // Tambahkan isPosPage sebagai dependensi

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(changeLayout("vertical"));
  }, [dispatch]);

  // ... (useEffect lainnya tetap sama) ...

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header toggleMenuCallback={toggleMenuCallback} />
        
        {/* ➡️ KUNCI 4: CONDITIONAL RENDERING SIDEBAR ⬅️ */}
        {!isPosPage && (
            <Sidebar
                theme={leftSideBarTheme}
                type={leftSideBarType}
                isMobile={isMobile}
            />
        )}

        {/* ➡️ KUNCI 5: MAIN CONTENT - CSS akan menghilangkan margin kiri jika isPosPage=true ⬅️ */}
        <div className="main-content">{props.children}</div>
        
        {/* Opsional: Sembunyikan Footer di halaman POS */}
        {!isPosPage && <Footer />}
      </div>
      {showRightSidebar ? <RightSidebar /> : null}
      {/* Tour panduan pertama kali + pemutar ulang dari halaman Panduan */}
      {!isPosPage && <PanduanTour />}
    </React.Fragment>
  );
};

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.any,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
};

export default withRouter(Layout);